import { LABEL_PUSH_PIN } from '../constants/labelValues';
const data = window.ppData;
const isStory = data.isStory ?? false;
const isTiles = data.isTiles ?? false;
const isCustomCanvas = data.isCustomCanvas ?? false;
const isCustomFramedCanvas = data.isCustomFramedCanvas ?? false;
const isCustomHexagon = data.isCustomHexagon ?? false;
const isCustomWallDisplay = data.isCustomWallDisplay ?? false;
const isOldCustom = isTiles ||
    isCustomCanvas ||
    isCustomFramedCanvas ||
    isCustomHexagon ||
    isCustomWallDisplay;
export const ppData = {
    ...data,
    isPushPin: data.labels?.includes(LABEL_PUSH_PIN) === true,
    isPersonalized: isStory || isOldCustom,
    isStory,
    isTiles,
    isCustomCanvas,
    isCustomFramedCanvas,
    isCustomHexagon,
    isCustomWallDisplay,
    isOldCustom,
    ...((isCustomCanvas || isCustomFramedCanvas || isCustomHexagon || isCustomWallDisplay) &&
        {
            customMasks: data.customMasks,
        })
};
